// extracted by mini-css-extract-plugin
module.exports = {"marker":"Marker_marker__1Eh3Q","text":"Marker_text__DmEes"};